// import React from "react";
// import { RouterProvider, createBrowserRouter } from "react-router-dom";
// import HomePage from "../pages/HomePage";
// import UpcomingPage from "../pages/UpcomingPage";
// import MatchPage from "../pages/MatchPage";
// import StandingsPage from "../pages/StandingsPage";
// import SearchPage from "../pages/SearchPage";
// import LoginPage from "../pages/LoginPage";
// import SignupPage from "../pages/SignupPage";
// import FantasyGamePage from "../pages/FantasyGamePage";
// import MatchContestsPage from "../pages/MatchContestsPage";
// import CreateTeamPage from "../pages/CreateTeamPage";
// import CreatedTeamPage from "../pages/CreatedTeamPage";
// import UserMatchesPage from "../pages/UserMatchesPage";
// import PointsPage from "../pages/PointsPage";
// import Auth from "../components/auth/Auth";
// import RecentPage from "../pages/RecentPage";
// import PageNotFound from "../pages/PageNotFound";
// import NotificationsPage from "../pages/NotificationsPage";
// import Profile from "../components/Profile";
// import ErrorBoundary from "../components/ErrorBoundary";
// import ShortzPage from "../pages/ShortzPage";
// import Matches from "../pages/Matches";
// // import Calendar from "../components/Calendar";

// const Routing = () => {
//   const router = createBrowserRouter([
//     {
//       path: "/",
//       element: <HomePage />,
//     },
//     {
//       path: "/recent/matches",
//       element: <RecentPage />,
//     },
//     {
//       path: "/upcoming/matches",
//       element: <UpcomingPage />,
//     },
//     {
//       path: "/match/:id/:homeTeamId/:awayTeamId",
//       element: <MatchPage />,
//     },
//     {
//       path: "/team/standings",
//       element: <StandingsPage />,
//     },
//     {
//       path: "/match/search",
//       element: <SearchPage />,
//     },
//     {
//       path: "/login",
//       element: <LoginPage />,
//     },
//     {
//       path: "/signup",
//       element: <SignupPage />,
//     },
//     {
//       path: "/fantasy/game",
//       element: <FantasyGamePage />,
//     },
//     {
//       path: "/match/contests/:id/:homeTeamId/:awayTeamId",
//       element: (
//         <Auth>
//           <MatchContestsPage />
//         </Auth>
//       ),
//     },
//     {
//       path: "/match/create-team/:id/:homeTeamId/:awayTeamId/:contestId",
//       element: (
//         <Auth>
//           <CreateTeamPage />
//         </Auth>
//       ),
//     },
//     {
//       path: "/match/created-team/:id/:homeTeamId/:awayTeamId/:contestId",
//       element: (
//         <Auth>
//           <CreatedTeamPage />
//         </Auth>
//       ),
//     },
//     {
//       path: "/user/matches",
//       element: <UserMatchesPage />,
//     },
//     {
//       path: "/user/points",
//       element: <PointsPage />,
//     },
//     {
//       path: "/notifications",
//       element: <NotificationsPage />,
//     },
//     {
//       path: "*",
//       element: <PageNotFound />,
//     },
//     {
//     path: "/profile",
//       element: 
//       (
//         <Auth>
//       <Profile/>
//        </Auth>
//       ),
//       errorElement: <ErrorBoundary />,
//     },
//      {
//       path: "/shortz",
//       element: (
//         // <Auth>
//         <ShortzPage />
//         // </Auth>
//       ),
//       errorElement: <ErrorBoundary />,
//     },
//       {
//       path: "/matches",
//       element: (
//         // <Auth>
//         <Matches />
//         // </Auth>
//       ),
//       errorElement: <ErrorBoundary />,
//     },
//     //    {
//     //   path: "/calendar",
//     //   element: (
//     //     // <Auth>
//     //     <Calendar/>
//     //     // </Auth>
//     //   ),
//     //   errorElement: <ErrorBoundary />,
//     // },
//   ]);
//   return <RouterProvider router={router} />;
// };

// export default Routing;



import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import RootLayout from "../components/RootLayout"; 
import HomePage from "../pages/HomePage";
import ShortzPage from "../pages/ShortzPage";
import UpcomingPage from "../pages/UpcomingPage";
import MatchPage from "../pages/MatchPage";
import StandingsPage from "../pages/StandingsPage";
import SearchPage from "../pages/SearchPage";
import LoginPage from "../pages/LoginPage";
import SignupPage from "../pages/SignupPage";
import FantasyGamePage from "../pages/FantasyGamePage";
import MatchContestsPage from "../pages/MatchContestsPage";
import CreateTeamPage from "../pages/CreateTeamPage";
import CreatedTeamPage from "../pages/CreatedTeamPage";
import UserMatchesPage from "../pages/UserMatchesPage";
import PointsPage from "../pages/PointsPage";
import Auth from "../components/auth/Auth";
import RecentPage from "../pages/RecentPage";
import PageNotFound from "../pages/PageNotFound";
import NotificationsPage from "../pages/NotificationsPage";
import Profile from "../components/Profile";
import ErrorBoundary from "../components/ErrorBoundary";
import Matches from "../pages/Matches";

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,   // ✅ wrapper
    children: [
      { index: true, element: <HomePage /> },
      { path: "recent/matches", element: <RecentPage /> },
      { path: "upcoming/matches", element: <UpcomingPage /> },
      { path: "match/:id/:homeTeamId/:awayTeamId", element: <MatchPage /> },
      { path: "team/standings", element: <StandingsPage /> },
      { path: "match/search", element: <SearchPage /> },
      // { path: "login", element: <LoginPage /> },
      // { path: "signup", element: <SignupPage /> },
      // { path: "fantasy/game", element: <FantasyGamePage /> },
      {
        path: "match/contests/:id/:homeTeamId/:awayTeamId",
        element: (
          <Auth>
            <MatchContestsPage />
          </Auth>
        ),
      },
      {
        path: "match/create-team/:id/:homeTeamId/:awayTeamId/:contestId",
        element: (
          <Auth>
            <CreateTeamPage />
          </Auth>
        ),
      },
      {
        path: "match/created-team/:id/:homeTeamId/:awayTeamId/:contestId",
        element: (
          <Auth>
            <CreatedTeamPage />
          </Auth>
        ),
      },
      { path: "user/matches", element: <UserMatchesPage /> },
      { path: "user/points", element: <PointsPage /> },
      { path: "notifications", element: <NotificationsPage /> },
      // {
      //   path: "profile",
      //   element: (
      //     <Auth>
      //       <Profile />
      //     </Auth>
      //   ),
      //   errorElement: <ErrorBoundary />,
      // },
      {
        path: "shortz",
        element: <ShortzPage />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "matches",
        element: <Matches />,
        errorElement: <ErrorBoundary />,
      },
      { path: "*", element: <PageNotFound /> },
    ],
  },
]);

const Routing = () => <RouterProvider router={router} />;

export default Routing;
